import { Col, Form, FormInstance } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { computePayoutAmount } from '../../utils/buybackHelpers'
import { IncreasingNumber } from '../IncreasingNumber/IncreasingNumber'
import { formatCurrencyNumber } from '../Money/Money'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const shouldUpdate = (prev: any, next: any) =>
  requiredFields.some(field => prev[field] !== next[field])

const requiredFields = [
  FIELD.OfferPrice,
  FIELD.CommissionAmount,
  FIELD.BaseCommissionAmount,
  FIELD.DebtAmountTotal,
  FIELD.DebtFeeTotal,
  FIELD.BaseDebtFeeTotal,
  FIELD.ProcessCostAmountTotal,
  FIELD.RequestedAmount,
] as const

const payoutRenderer: (form: FormInstance) => React.ReactNode = ({
  getFieldsValue,
}) => {
  const fieldsValue = getFieldsValue([...requiredFields])

  const { [FIELD.RequestedAmount]: requestedAmountRaw, ...values } = fieldsValue
  const amount = computePayoutAmount(values)

  const requestedAmount = requestedAmountRaw ?? 0
  const requestedBalance = amount - requestedAmount

  const className =
    amount < 0
      ? 'text-red-600'
      : requestedBalance < 0
      ? 'text-orange-400'
      : 'text-lime-600'

  const description =
    amount < 0
      ? '(závazky převyšují nabídku)'
      : requestedBalance < 0
      ? `(nedosahuje požadavku ${formatCurrencyNumber(requestedAmount, 0)} Kč)`
      : ''

  return (
    <>
      <IncreasingNumber
        finalNumber={amount}
        decimal={0}
        suffix=" Kč"
        className={'text-2xl font-semibold ' + className}
      />
      <div className={className}>{description}</div>
    </>
  )
}
export const BuybackFormSummaryFragmentPayout: FunctionComponent<{
  onClick?: () => void
}> = memo(({ onClick }) => {
  return (
    <Col xs={24} md={12} xl={8} className="text-center">
      <div className="mb-2">Částka k vyplacení na účet prodávajícího</div>
      <Form.Item noStyle shouldUpdate={shouldUpdate}>
        {({ getFieldsValue }) => {
          const el = payoutRenderer({ getFieldsValue } as FormInstance)
          return (
            <div
              className="cursor-pointer hover:opacity-80"
              onClick={onClick}
              role={onClick ? 'button' : undefined}
            >
              {el}
            </div>
          )
        }}
      </Form.Item>
    </Col>
  )
})
